'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Node = require('./avl-tree-node.js');

var AVLTree =
/*#__PURE__*/
function () {
  function AVLTree() {
    _classCallCheck(this, AVLTree);

    this.root = null;
    this.imbalancedNode = null;
    this.imbalancedNodeParent = null;
  }

  _createClass(AVLTree, [{
    key: "insert",
    value: function insert(value, cb) {
      var _this = this;

      if (!this.isNumericInput(value)) {
        return undefined;
      }

      value = Number(value);
      var newNode = new Node(value);

      if (this.treeIsEmpty()) {
        this.root = newNode;
        return newNode;
      }

      var go = function go(node) {
        if (cb) {
          cb();
        }

        if (value === node.value) {
          return undefined;
        } // value already in tree
        // add right node


        if (!node.right && value > node.value) {
          node.right = newNode;

          _this.updateNodeHeight(node);

          return newNode;
        } // add left node


        if (!node.left && value < node.value) {
          node.left = newNode;

          _this.updateNodeHeight(node);

          return newNode;
        }

        var result; // navigate right

        if (value > node.value) {
          result = go(node.right);
        } else if (value < node.value) {
          // navigate left
          result = go(node.left);
        } // done with recursion


        _this.fixImbalances(node);

        _this.setImbalancedNode(node);

        _this.updateNodeHeight(node);

        return result;
      };

      var result = go(this.root);
      this.handleRootImbalance();
      this.imbalancedNode = null;
      this.imbalancedNodeParent = null;
      return result;
    }
  }, {
    key: "remove",
    value: function remove(value, cb) {
      var _this2 = this;

      if (!this.isNumericInput(value)) {
        return undefined;
      }

      value = Number(value);

      if (this.treeIsEmpty()) {
        return undefined;
      }

      if (cb) {
        cb();
      }

      if (this.root.value === value) {
        if (!this.root.left && !this.root.right) {
          var _result = this.root;
          this.root = null;
          return _result;
        }
      }

      var go = function go(node) {
        if (cb) {
          cb();
        }

        var result; // root node is the value

        if (node.value === value) {
          // located node to be deleted
          result = new Node(node.value); // remove the node

          _this2.root = _this2.removeNode(node, cb);

          _this2.fixImbalances(node);

          if (_this2.root) {
            _this2.updateNodeHeight(_this2.root);
          }

          return result;
        }

        if (node.right && node.right.value === value) {
          // located node to be deleted
          result = new Node(node.right.value); // remove the node

          node.right = _this2.removeNode(node.right, cb);

          if (node.right) {
            _this2.updateNodeHeight(node.right);
          }

          _this2.updateNodeHeight(node); // check for problem nodes


          _this2.setImbalancedNode(node);

          return result;
        }

        if (node.left && node.left.value === value) {
          // located node to be deleted
          result = new Node(node.left.value); // remove the node

          node.left = _this2.removeNode(node.left, cb);

          if (node.left) {
            _this2.updateNodeHeight(node.left);
          }

          _this2.updateNodeHeight(node); // check for problem nodes


          _this2.setImbalancedNode(node);

          return result;
        } // navigate right


        if (value > node.value) {
          if (!node.right) {
            return undefined;
          }

          result = go(node.right);
        } else if (value < node.value) {
          // navigate left
          if (!node.left) {
            return undefined;
          }

          result = go(node.left);
        } // done with recursion


        _this2.fixImbalances(node);

        _this2.setImbalancedNode(node); // this.imbalancedNode = null;


        _this2.updateNodeHeight(node);

        return result;
      };

      var result = go(this.root); // root is gone

      if (!this.root) {
        return result;
      }

      this.handleRootImbalance();
      this.imbalancedNode = null;
      this.imbalancedNodeParent = null;
      return result;
    }
  }, {
    key: "removeNode",
    value: function removeNode(node, cb) {
      // if leaf, remove
      if (!node.left && !node.right) {
        return null;
      } // if two children --> Find sub tree min or max --> replace that node


      if (node.left && node.right) {
        return this.removeNodeWithTwoChildren(node, cb);
      } // if only one child, make that child the new node


      if (node.left) {
        return node.left;
      }

      return node.right;
    }
  }, {
    key: "removeNodeWithTwoChildren",
    value: function removeNodeWithTwoChildren(node, cb) {
      var _this3 = this;

      var maxNodeValueOfSubTree;
      var minNodeValueOfSubTree;

      var deleteMin = function deleteMin(node) {
        if (cb) {
          cb();
        } // base case


        if (!node.left) {
          minNodeValueOfSubTree = node.value;

          if (!node.right) {
            return null;
          }

          return node.right;
        }

        var result = deleteMin(node.left);

        if (result === true) {
          _this3.fixImbalances(node);

          _this3.setImbalancedNode(node);

          _this3.updateNodeHeight(node);

          return result;
        }

        node.left = result;

        _this3.updateNodeHeight(node);

        if (node.left) {
          _this3.updateNodeHeight(node.left);
        }

        _this3.setImbalancedNode(node);

        return true;
      };

      var deleteMax = function deleteMax(node, cb) {
        if (cb) {
          cb();
        } // base case


        if (!node.right) {
          maxNodeValueOfSubTree = node.value;

          if (!node.left) {
            return null;
          }

          return node.left;
        }

        var result = deleteMax(node.right, cb);

        if (result === true) {
          _this3.fixImbalances(node);

          _this3.setImbalancedNode(node);

          _this3.updateNodeHeight(node);

          return result;
        }

        node.right = result;

        _this3.updateNodeHeight(node);

        if (node.right) {
          _this3.updateNodeHeight(node.right);
        }

        _this3.setImbalancedNode(node);

        return true;
      };

      var result;

      if (node.left.height > node.right.height) {
        result = deleteMax(node.left, cb);
        node.value = maxNodeValueOfSubTree;

        if (result === true) {
          this.fixImbalances(node);
          this.setImbalancedNode(node);
        } else {
          node.left = result;
          this.updateNodeHeight(node);

          if (node.left) {
            this.updateNodeHeight(node.left);
          }

          this.setImbalancedNode(node);
        }
      } else {
        result = deleteMin(node.right);
        node.value = minNodeValueOfSubTree;

        if (result === true) {
          this.fixImbalances(node);
          this.setImbalancedNode(node);
        } else {
          node.right = result;
          this.updateNodeHeight(node);

          if (node.right) {
            this.updateNodeHeight(node.right);
          }

          this.setImbalancedNode(node);
        }
      }

      return node;
    }
  }, {
    key: "handleRootImbalance",
    value: function handleRootImbalance() {
      if (this.isImbalanced(this.root)) {
        this.performRotations(this.root);
        this.imbalancedNode = null;
        this.imbalancedNodeParent = null;
      }

      if (this.root.left && this.isImbalanced(this.root.left)) {
        this.imbalancedNode = this.root.left;
        this.imbalancedNodeParent = this.root;
        this.fixImbalances(this.root);
      }

      if (this.root.right && this.isImbalanced(this.root.right)) {
        this.imbalancedNode = this.root.right;
        this.imbalancedNodeParent = this.root;
        this.fixImbalances(this.root);
      }
    }
  }, {
    key: "fixImbalances",
    value: function fixImbalances(node) {
      if (this.imbalancedNode) {
        var problemNodeDirection = this.getProblemNodeDirection(node, this.imbalancedNode);
        this.performRotations(this.imbalancedNode, node, problemNodeDirection);

        while (this.imbalancedNode) {
          var _node = this.imbalancedNode;
          var parent = this.imbalancedNodeParent;

          var _problemNodeDirection = this.getProblemNodeDirection(parent, _node);

          this.performRotations(_node, parent, _problemNodeDirection);
        }

        this.imbalancedNode = null;
        this.imbalancedNodeParent = null;
      }
    }
  }, {
    key: "getProblemNodeDirection",
    value: function getProblemNodeDirection(node, imbalancedNode) {
      if (node && node.left && node.left.value === imbalancedNode.value) {
        return 'left';
      }

      if (node && node.right && node.right.value === imbalancedNode.value) {
        return 'right';
      }

      return undefined;
    }
  }, {
    key: "performRotations",
    value: function performRotations(originalRoot, parentNode, problemNodeDirection) {
      var leftHeight = this.getHeight(originalRoot.left);
      var rightHeight = this.getHeight(originalRoot.right);

      if (leftHeight - rightHeight >= 2) {
        this.handleLeftImbalance(originalRoot, parentNode, problemNodeDirection);
      }

      if (rightHeight - leftHeight >= 2) {
        this.handleRightImbalance(originalRoot, parentNode, problemNodeDirection);
      }
    }
  }, {
    key: "handleRightImbalance",
    value: function handleRightImbalance(originalRoot, parentNode, problemNodeDirection) {
      var rightChild = originalRoot.right;
      var rightChildLeftHeight = this.getHeight(rightChild.left);
      var rightChildRightHeight = this.getHeight(rightChild.right);

      if (rightChildRightHeight > rightChildLeftHeight) {
        this.handleSingleRightRotation(originalRoot, parentNode, problemNodeDirection);
      } else {
        this.handleDoubleRightRotation(originalRoot, parentNode, problemNodeDirection);
      }
    }
  }, {
    key: "handleLeftImbalance",
    value: function handleLeftImbalance(originalRoot, parentNode, problemNodeDirection) {
      var leftChild = originalRoot.left;
      var leftChildLeftHeight = this.getHeight(leftChild.left);
      var leftChildRightHeight = this.getHeight(leftChild.right);

      if (leftChildLeftHeight > leftChildRightHeight) {
        this.handleSingleLeftRotation(originalRoot, parentNode, problemNodeDirection);
      } else {
        this.handleDoubleLeftRotation(originalRoot, parentNode, problemNodeDirection);
      }
    }
  }, {
    key: "handleDoubleLeftRotation",
    value: function handleDoubleLeftRotation(originalRoot, parentNode, problemNodeDirection) {
      var leftSubTree;
      var rightSubTree;
      var newRoot;

      if (!parentNode) {
        rightSubTree = this.root;
        leftSubTree = originalRoot.left;
        newRoot = leftSubTree.right;
        leftSubTree.right = newRoot.left;
        rightSubTree.left = newRoot.right;
        newRoot.left = leftSubTree;
        newRoot.right = rightSubTree;
        this.root = newRoot;
      } else {
        rightSubTree = originalRoot;
        leftSubTree = originalRoot.left;
        newRoot = leftSubTree.right;
        leftSubTree.right = newRoot.left;
        rightSubTree.left = newRoot.right;
        newRoot.left = leftSubTree;
        newRoot.right = rightSubTree;
        parentNode[problemNodeDirection] = newRoot;
      }

      this.updateNodeHeight(leftSubTree);
      this.updateNodeHeight(rightSubTree);
      this.updateNodeHeight(newRoot);
      this.imbalancedNode = null;
      this.imbalancedNodeParent = null;
      this.setImbalancedNodeFromParent(newRoot);
    }
  }, {
    key: "handleDoubleRightRotation",
    value: function handleDoubleRightRotation(originalRoot, parentNode, problemNodeDirection) {
      var leftSubTree;
      var rightSubTree;
      var newRoot;

      if (!parentNode) {
        leftSubTree = this.root;
        rightSubTree = originalRoot.right;
        newRoot = rightSubTree.left;
        leftSubTree.right = newRoot.left;
        rightSubTree.left = newRoot.right;
        newRoot.left = leftSubTree;
        newRoot.right = rightSubTree;
        this.root = newRoot;
      } else {
        leftSubTree = originalRoot;
        rightSubTree = originalRoot.right;
        newRoot = rightSubTree.left;
        leftSubTree.right = newRoot.left;
        rightSubTree.left = newRoot.right;
        newRoot.left = leftSubTree;
        newRoot.right = rightSubTree;
        parentNode[problemNodeDirection] = newRoot;
      }

      this.updateNodeHeight(leftSubTree);
      this.updateNodeHeight(rightSubTree);
      this.updateNodeHeight(newRoot);
      this.imbalancedNode = null;
      this.imbalancedNodeParent = null;
      this.setImbalancedNodeFromParent(newRoot);
    }
  }, {
    key: "handleSingleLeftRotation",
    value: function handleSingleLeftRotation(originalRoot, parentNode, problemNodeDirection) {
      var newRoot = originalRoot.left;
      originalRoot.left = newRoot.right;
      newRoot.right = originalRoot;

      if (!parentNode) {
        this.root = newRoot;
      } else {
        parentNode[problemNodeDirection] = newRoot;
      }

      this.updateNodeHeight(newRoot.left);
      this.updateNodeHeight(newRoot.right);
      this.updateNodeHeight(newRoot);
      this.imbalancedNode = null;
      this.imbalancedNodeParent = null;
      this.setImbalancedNodeFromParent(newRoot);
    }
  }, {
    key: "handleSingleRightRotation",
    value: function handleSingleRightRotation(originalRoot, parentNode, problemNodeDirection) {
      var newRoot = originalRoot.right;
      originalRoot.right = newRoot.left;
      newRoot.left = originalRoot;

      if (!parentNode) {
        this.root = newRoot;
      } else {
        parentNode[problemNodeDirection] = newRoot;
      }

      this.updateNodeHeight(newRoot.left);
      this.updateNodeHeight(newRoot.right);
      this.updateNodeHeight(newRoot);
      this.imbalancedNode = null;
      this.imbalancedNodeParent = null;
      this.setImbalancedNodeFromParent(newRoot);
    }
  }, {
    key: "getHeight",
    value: function getHeight(node) {
      if (!node) {
        return -1;
      }

      return node.height;
    }
  }, {
    key: "setImbalancedNode",
    value: function setImbalancedNode(node) {
      if (!this.imbalancedNode && this.isImbalanced(node)) {
        this.imbalancedNode = node; // set parent?
      }
    }
  }, {
    key: "setImbalancedNodeFromParent",
    value: function setImbalancedNodeFromParent(parentNode) {
      if (parentNode.left && this.isImbalanced(parentNode.left)) {
        this.imbalancedNode = parentNode.left;
        this.imbalancedNodeParent = parentNode;
      }

      if (parentNode.right && this.isImbalanced(parentNode.right)) {
        this.imbalancedNode = parentNode.right;
        this.imbalancedNodeParent = parentNode;
      }
    }
  }, {
    key: "isImbalanced",
    value: function isImbalanced(node) {
      var leftHeight = this.getHeight(node.left);
      var rightHeight = this.getHeight(node.right);

      if (Math.abs(leftHeight - rightHeight) >= 2) {
        return true;
      }

      return undefined;
    }
  }, {
    key: "updateNodeHeight",
    value: function updateNodeHeight(node) {
      if (!node.left && !node.right) {
        node.height = 0;
        return;
      }

      if (!node.left) {
        node.height = node.right.height + 1;
        return;
      }

      if (!node.right) {
        node.height = node.left.height + 1;
        return;
      }

      if (node.left && node.right) {
        node.height = Math.max(node.left.height, node.right.height) + 1;
      }
    }
  }, {
    key: "treeIsEmpty",
    value: function treeIsEmpty() {
      if (!this.root) {
        return true;
      }

      return false;
    }
  }, {
    key: "isNumericInput",
    value: function isNumericInput(value) {
      if (typeof value === 'boolean') {
        return false;
      }

      var numericalValue = Number(value);

      if (Number.isNaN(numericalValue)) {
        return false;
      }

      if (typeof numericalValue === 'number') {
        return true;
      }

      return false;
    }
  }, {
    key: "contains",
    value: function contains(value, cb) {
      if (!this.isNumericInput(value)) {
        return undefined;
      }

      value = Number(value);

      if (this.treeIsEmpty()) {
        return false;
      }

      var go = function go(node) {
        // base case
        if (cb) {
          cb();
        }

        if (node.value === value) {
          return true;
        }

        if (!node.left && !node.right) {
          return false;
        }

        if (value < node.value) {
          if (node.left) {
            return go(node.left);
          }

          return false;
        }

        if (value > node.value) {
          if (node.right) {
            return go(node.right);
          }

          return false;
        }

        return undefined;
      };

      var result = go(this.root);
      return result;
    }
  }, {
    key: "findMin",
    value: function findMin(cb) {
      if (this.treeIsEmpty()) {
        return undefined;
      }

      var current = this.root;

      while (current.left) {
        if (cb) {
          cb();
        }

        current = current.left;
      }

      return current.value;
    }
  }, {
    key: "findMax",
    value: function findMax(cb) {
      if (this.treeIsEmpty()) {
        return undefined;
      }

      var current = this.root;

      while (current.right) {
        if (cb) {
          cb();
        }

        current = current.right;
      }

      return current.value;
    }
  }, {
    key: "printPreOrder",
    value: function printPreOrder() {
      var result = [];

      if (this.treeIsEmpty()) {
        return result;
      }

      var go = function go(node) {
        result.push(node.value);

        if (node && node.left) {
          go(node.left);
        }

        if (node && node.right) {
          go(node.right);
        }
      };

      go(this.root);
      return result;
    }
  }, {
    key: "printInOrder",
    value: function printInOrder() {
      var result = [];

      if (this.treeIsEmpty()) {
        return result;
      }

      var go = function go(node) {
        if (node && node.left) {
          go(node.left);
        }

        result.push(node.value);

        if (node && node.right) {
          go(node.right);
        }
      };

      go(this.root);
      return result;
    }
  }, {
    key: "printPostOrder",
    value: function printPostOrder() {
      var result = [];

      if (this.treeIsEmpty()) {
        return result;
      }

      var go = function go(node) {
        if (node && node.left) {
          go(node.left);
        }

        if (node && node.right) {
          go(node.right);
        }

        result.push(node.value);
      };

      go(this.root);
      return result;
    }
  }, {
    key: "containsDuplicates",
    value: function containsDuplicates() {
      var seen = new Set();
      var inOrderArray = this.printInOrder();

      for (var i = 0; i < inOrderArray.length; i += 1) {
        var current = inOrderArray[i];

        if (seen.has(current)) {
          return true;
        }

        seen.add(current);
      }

      return false;
    }
  }, {
    key: "containsHeightErrors",
    value: function containsHeightErrors() {
      var _this4 = this;

      var result = false;

      if (this.treeIsEmpty()) {
        return false;
      }

      var go = function go(node) {
        if (node && node.left) {
          go(node.left);
        }

        if (node && node.right) {
          go(node.right);
        }

        if (_this4.isImbalanced(node)) {
          result = true;
        }
      };

      go(this.root);
      return result;
    }
  }]);

  return AVLTree;
}();

module.exports = AVLTree;